export default {
  getTheme(id) {
    return axios.get(`/themes/${id}`)
  },
  getMultiple(ids) {
    return axios.get(`/themes`, { params: {ids} })
  }
}
